<div class="container-theme">
    <div [ngClass]="Theme" #boxImportante *ngIf="viewIn">
      <div class="scene" *ngIf="Theme === 'box-importante-custom'">
        <div class="r1">
            <app-icon [Path]="'./assets/img/rombo_1.svg'"></app-icon>
        </div>
        <div class="r2">
            <app-icon [Path]="'./assets/img/rombo_1.svg'"></app-icon>
        </div>
      </div>
  
      <div class="btn-cerrar" (click)="cerrar()">
        
        <ng-container *ngIf=" Theme !== 'box-importante-custom' && Theme !== 'box-importante banner-BA' ">
          <app-icon [Path]="'./assets/img/ico_cerrar_base.svg'"></app-icon>
        </ng-container>
  
        <ng-container *ngIf=" Theme === 'box-importante-custom' ||  Theme === 'box-importante banner-BA' ">
          <app-icon [Path]="'./assets/img/ico_cerrar_base_blue.svg'"></app-icon>
        </ng-container>      
      </div>
  
      <div
        [ngClass]="
          Theme === 'box-importante-custom'
            ? 'wrapper-important-custom'
            : 'wrapper-important'
        "
      >
        <ng-container
          *ngIf="          
            Theme === 'box-importante-xl' ||
            Theme === 'box-importante-l' ||
            Theme === 'box-importante-lb' ||
            Theme === 'box-importante-custom'
          "
        >
          <div class="head">          
            <h2>{{ titulo }}</h2>
          </div>        
          <div class="body">
            <ng-content select="[mensage]"></ng-content>
          </div>
        </ng-container>
  
        <ng-container *ngIf="
          Theme === 'banner-important' ||
          Theme === 'box-importante banner-BA' ||
          Theme === 'banner-important-excendentes' ||
          Theme === 'banner-important-excendentes-por-restitucion'
        ">
          <div class="left">
            <div class="head">
              <ng-container *ngIf="Theme != 'box-importante banner-BA' ">
                <h2>{{ titulo }}</h2>
              </ng-container>
              <ng-container *ngIf="Theme === 'box-importante banner-BA' ">              
                <ng-content select="[thumb-doctoro-online]"></ng-content>
                <ng-content select="[title-doctor-online]"></ng-content>
              </ng-container>
  
            </div>
            <div class="body">
              <ng-container *ngIf="Theme === 'box-importante banner-BA' ">
                <h2>{{ titulo }}</h2>
              </ng-container>
              <ng-content select="[mensage-important]"></ng-content>
            </div>
          </div>
          <div class="right">
            <ng-content select="[callToAction-important]"></ng-content>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  